module.exports = __webpack_public_path__ + "static/img/1_0037.f4a421d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/tech/1_0037.jpg
// module id = lC8I
// module chunks = 0